import { RequestAction } from '@/request/requestRouter'
import type { ApiRequest, RequestRoutes } from '@/request/requestRouter'
import checkNotificationMiddleware from '@/request/middlewares/notification'

const redeemG2A: ApiRequest = {
	action: RequestAction.RedeemG2A,
	endpoint: 'g2a/redeem/{{serialKey}}',
	config: {
		method: 'POST',
		credentials: 'include',
	},
}

export default {
	prefix: '/api',
	middlewares: [checkNotificationMiddleware],
	queries: [
		redeemG2A,
	],
} as RequestRoutes
